<template>

  <div class="text-black bg-white pt-5 pb-5">

    <div id="register-container" class="container">
        
        <loading :active.sync="isLoading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage">
        </loading>
        
        <div v-if="!registered">

            <div class="h1">
              Registrati per essere visibile sulla mappa
            </div>
            <br>
            <div class="row">
                <div class="col-md-2 col-xs-2"></div>
                <div class="col-md-8 col-xs-8">
                    <form  @submit.prevent="registerForm">
                        <div class="form-group">
                            <div class="h2">
              					Le tue informazioni:
            				</div>
                        </div>
                        <div class="form-group">
                            <label for="name">Inserisci il nome della tua attività</label>
                            <input type="text" class="form-control" id="name" v-model="name" placeholder="">
                            <span v-if="error.name" class="text-danger">
                                {{ error.name }}
                            </span>
                        </div>
                        <div class="form-group">
                            <label for="address">Descrivi brevemente la tua attività (max 120 caratteri)</label>
                            <textarea rows="5" class="form-control" id="description" v-model="description" placeholder="" maxlength="120"></textarea>
                            <span v-if="error.description" class="text-danger">
                                {{ error.description }}
                            </span>
                        </div>
                        <div class="form-group">
                            <label for="categories_id">Seleziona fino a 3 categorie</label>
                            <multiselect v-model="category" tag-placeholder="Seleziona categoria" placeholder="Seleziona categoria" label="name" track-by="id"
                                         :options="categories" 
                                         :multiple="true" 
                                         :taggable="true"></multiselect>
                            <span v-if="error.category" class="text-danger">
                                {{ error.category }}
                            </span>
                        </div>
                        <div class="form-group">
                            <label for="address">Inserisci il tuo indirizzo</label>
                            <input type="text" class="form-control" id="address" v-model="address" placeholder="">
                            <span v-if="error.address" class="text-danger">
                                {{ error.address }}
                            </span>
                        </div>
                        <div class="form-group">
                        	<div class="row">
	                            <div class="col-6 pl-0 m-0">
	                                <label for="address">Città</label>
	                                <input type="text" class="form-control" id="city" v-model="city" placeholder="">
	                                <span v-if="error.city" class="text-danger">
	                                    {{ error.city }}
	                                </span>
	                            </div>
	                            <div class="col-6 p-0 m-0">
	                                <label for="address">CAP</label>
	                                <input type="number" class="form-control" id="cap" v-model="cap" placeholder="">
	                                <span v-if="error.cap" class="text-danger">
	                                    {{ error.cap }}
	                                </span>
	                            </div>
	                    	</div>        
                        </div>
                        <div class="form-group">
                            <label for="website">Inserisci il tuo sito web</label>
                            <input type="text" class="form-control" id="website" v-model="website" placeholder="">
                            <span v-if="error.website" class="text-danger">
                                {{ error.website }}
                            </span>
                        </div>
                        <hr>
                        <div class="form-group">
                            <div class="h2">
              					Canali di contatto:
            				</div>
                        </div>
                        <div class="form-group">
                            <label for="phone">Telefono / Cellulare</label>
                            <input type="number" class="form-control" id="phone" v-model="phone" placeholder="">
                            <span v-if="error.phone" class="text-danger">
                                {{ error.phone }}
                            </span>
                        </div>
                        <div class="form-group">
                            <label for="phone">Inserisci il tuo numero di Whatsapp</label>
                            <input type="number" class="form-control" id="whatsapp" v-model="whatsapp" placeholder="">
                            <span v-if="error.whatsapp" class="text-danger">
                                {{ error.whatsapp }}
                            </span>
                        </div>
                        <div class="form-group">
                            <label for="telegram">Inserisci il link al tuo gruppo Telegram</label>
                            <input type="text" class="form-control" id="telegram" v-model="telegram" placeholder="">
                            <span v-if="error.telegram" class="text-danger">
                                {{ error.telegram }}
                            </span>
                        </div>
                        <div class="form-group">
                            <label for="facebook">Inserisci il link alla tua pagina Facebook</label>
                            <input type="text" class="form-control" id="facebook" v-model="facebook" placeholder="">
                            <span v-if="error.facebook" class="text-danger">
                                {{ error.facebook }}
                            </span>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="acceptsTermsAndConditions" required>
                            <label class="form-check-label" for="exampleCheck1">
                                Registrando il mio negozio do il
                                consenso a utilizzare le informazioni condivise per l'utilizzo all'interno della piattaforma e per post, articoli sul web
                                che hanno il fine di promuoverne l’utilizzo. </label>
                        </div>
                        <br>
                        <div class="col-6">
                          <button type="submit" class="btn btn-success btn-block btn-style">Registrati</button>
                        </div>
                        <br>
                        <h5 v-if="error.general" class="text-danger">
                            {{ error.general }}
                        </h5>
                    </form>
                </div>
                <div class="col-md-2 col-xs-2"></div>
            </div>
        </div>

        <div v-else>
            <br>
            <br>
            <div class="text-center">
                <h2>Complimenti!</h2>
                <h4>La registrazione è avvenuta con successo.</h4>
                <br>
                <h5>
                  <router-link to="/mappa">Vai alla mappa</router-link>
                </h5>
            </div>
            <br>
            <br>
        </div>

    </div>

  </div>

</template>

<script>

  // Import axios
  import axios from 'axios'

  // Import component
  import Loading from 'vue-loading-overlay'

  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  import * as _ from "lodash";

  let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
  
  let regex = new RegExp(expression);

  let phoneExp = /^[+]*[(]?[0-9]{1,4}[)]?[-\s/0-9]*$/gi;
  
  let phoneRegexp = new RegExp(phoneExp);

  export default {
    name: "ProducerRegistration",
    components: {
      Loading
    },
    data() {
      return {
        categories: [],
        name: null,
        description: null,
        categories_ids: [],
        address: null,
        city: null,
        cap: null,
        website: '',
        phone: null,
        telegram: null,
        facebook: null,
        registered: true,
        category: [],
        whatsapp: null,
        acceptsTermsAndConditions: false,
        isLoading: false,
        fullPage: true,
        error: {
          general: false,
          name: false,
          description: false,
          address: false,
          city: false,
          cap: false,
          website: false,
          facebook: false,
          telegram: false,
          phone: false,
          category: false,
          whatsapp: false,
        },
        coordinates: {
          lat: '',
          lng: '',
        }
      }
    },
    created() {
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:1760072,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    },
    mounted() {

      this.registered = false;
      
      axios.get(process.env.VUE_APP_API_URL+'/categories', { headers: {
        'Content-Type': 'application/json',
        }})
        .then(response => {
          response.data.map(category => {
            this.categories.push({
              id: category.id,
              name: category.name
            })
          });
        })
        .catch(error => (console.log(error)));
    },
    methods: {

      registerForm: function (e) {
        
        this.error = _.mapValues(this.error, () => false);

        if (!this.name) {
          this.error.name = 'Non hai inserito il nome.'
        }
        if(!this.description){
          this.error.description = 'Non hai inserito la descrizione.'
        } else if (this.description && this.description.length > 120) {
          this.error.description = 'La descrizione che hai inserito è troppo lunga.'
        }
        if (!this.address) {
          this.error.address = 'Non hai inserito il tuo indirizzo.'
        }
        if (!this.city) {
          this.error.city = 'Non hai inserito la tua città.'
        }
        if (!this.cap) {
          this.error.cap = 'Non hai inserito il tuo CAP.'
        }
        if (this.cap && this.cap.length !== 5) {
          this.error.cap = 'Non hai inserito un CAP valido.'
        }
        if (this.website && !this.website.match(regex)) {
          this.error.website = 'Non hai inserito un link valido al sito web.'
        }
        if (!this.phone && !this.facebook && !this.telegram && !this.whatsapp) {
          this.error.phone = 'Inserire almeno un contatto.'
        }
        if (this.phone && !this.phone.match(phoneRegexp)) {
          this.error.phone = 'Il numero di telefono inserito non è valido.'
        }
        if (this.whatsapp && !this.whatsapp.match(phoneRegexp)) {
          this.error.whatsapp = 'Il numero di cellulare inserito non è valido.'
        }
        if (!this.acceptsTermsAndConditions) {
          this.error.general = 'Per registrarti devi accettare le condizioni.'
        }
        if (this.facebook && !this.facebook.match(regex)){
          this.error.facebook = "Il link alla pagina Facebook non è valido."
        }
        if (this.telegram && !this.telegram.match(regex)){
          this.error.telegram = "Il link al gruppo Telegram non è valido."
        }
        if (this.category && this.category.length > 3) {
          this.error.category = 'Puoi selezionare massimo 3 categorie.'
        } else if (!this.category) {
          this.error.category = 'Seleziona almeno una categoria.'
        }
        if (_.some(this.error)) {
          this.error.general = 'Dati non validi.';
          e.preventDefault();
          return
        } else {
          this.register()
        }
      },

      register() {
        
        this.isLoading = true;

        let params = {
          street:  this.address,
          city:  this.city,
          cap: this.cap,
          county: "IT",
          format: "json"
        }
        
        axios.get('https://nominatim.openstreetmap.org/search', {params: params})
          .then(response => {
            
            console.log(response.data[0]);
            
            if(response.data[0] === undefined) {
            
				this.isLoading = false;
				this.error.address = "Indirizzo non trovato, controlla l'indirizzo che hai inserito e riprova."
			
			} else {
            
		            this.coordinates.lat = response.data[0].lat;
		            this.coordinates.lng = response.data[0].lon;
		
		            var bodyFormData = new FormData();
		
		            bodyFormData.set('name', this.name);
		            bodyFormData.set('description',this.description);
		            bodyFormData.set('address', this.address);
		
					bodyFormData.set('categories_ids', this.category.map(x => x.id));
					bodyFormData.set('categories', []);
					
		            bodyFormData.set('city', this.city);
		            bodyFormData.set('cap', this.cap);
		            bodyFormData.set('acceptsTermsAndConditions', this.acceptsTermsAndConditions);
		            bodyFormData.set('lat', this.coordinates.lat);
		            bodyFormData.set('lng', this.coordinates.lng);
		
		            if (this.website) {
		              bodyFormData.set('website', this.website);
		            }
		            if (this.phone) {
		              bodyFormData.set('phone', this.phone);
		            }
		            if (this.whatsapp) {
		              bodyFormData.set('whatsapp', this.whatsapp);
		            }
		            if (this.telegram) {
		              bodyFormData.set('telegram', this.telegram);
		            }
		            if (this.facebook) {
		              bodyFormData.set('facebook', this.facebook);
		            }
		
		          axios.post(process.env.VUE_APP_API_URL+'/shop', 
		          			 bodyFormData, 
		          			 { headers: {'Content-Type': 'application/json'} })
		          .then(response => {
		
		              console.log(response);
		
		              this.registered = true;
		
		              this.isLoading = false;
		
		            }
		          )
		          .catch((e) => {
		            
		              this.isLoading = false;
		
		              this.error.general = "Errore nell'inserimento della tua attività nel database. Alcune delle cause frequenti: indirizzo non trovato, controlla l'indirizzo che hai inserito; i campi testuali contengono caratteri non ammessi, controlla i campi che hai inserito; indisponibilità momentanea del database, riprovare."
		
		              console.log(e.response);
		
		          });
		          
		     } //end else

          })
          .catch(error => {

            this.isLoading = false;

            this.error.general = "Errore nell'inserimento della tua attività nel database. Alcune delle cause frequenti: indirizzo non trovato, controlla l'indirizzo che hai inserito; i campi testuali contengono caratteri non ammessi, controlla i campi che hai inserito; indisponibilità momentanea del database, riprovare."

            console.log(error);

          });

      },
      onCancel() {
        console.log('User cancelled the loader.')
      }
    }
  }
</script>

<!-- Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

    #register-container {
        padding-bottom: 80px;
    }

    /*
    *  Remove arrows in input number
    *  Chrome, Safari, Edge, Opera
    */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

</style>
